module.exports = __webpack_public_path__ + "static/media/apartment4.c7326726.jpg";